export default "__VITE_ASSET__e3d5cf2d__"